<template>
  <Accordion
    id="chapter"
    :activeIndex="activeChapterIndex"
    @tab-open="storeChapter.selectChapter($event.index)"
    class="custom-details"
    lazy
  >
    <AccordionTab
      v-for="(chapter, chapterIndex) in storeChapter.chapters"
      :key="chapter.id"
      :disabled="
        storeChapter.chapters[0] !== chapter &&
        !storeChapter.chapters[chapterIndex - 1]?.done
      "
    >
      <template #header>
        <header class="flex justify-between items-center w-full">
          <div class="flex gap-2 items-center">
            <v-icon
              name="hi-solid-check-circle"
              :class="[chapter.done ? 'text-green-600' : '']"
            />
            <p class="line-clamp-2" :title="chapter.name">
              {{ chapter.name }}
            </p>
          </div>
        </header>
      </template>
      <slot />
    </AccordionTab>
  </Accordion>
</template>

<script lang="ts">
import { useChapterStore } from "@/store/linear/chapter";
import { storeToRefs } from "pinia";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "SidebarChapters",
  setup() {
    const storeChapter = useChapterStore;
    const { currentChapterIndex } = storeToRefs(storeChapter);

    const activeChapterIndex = computed({
      get: () => currentChapterIndex.value,
      set: (newIndex) => {
        if (newIndex !== null) storeChapter.selectChapter(newIndex);
      },
    });

    return { storeChapter, activeChapterIndex };
  },
});
</script>

<style lang="scss">
.custom-details {
  .p-accordion-header .p-accordion-header-link {
    background-color: white;
    border: 0px 0px 1px 0px;
  }
  .p-accordion-content {
    padding: 0;
    margin: 0;
  }
}
</style>
